// Preload hero images BEFORE React boots
import "./lib/preloadHeroes";

import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);
